export function bulk(customers) {
    return {
        type: 'CUSTOMERS_UPDATE_DATA_BULK',
        customers
    };
}
